import { __decorate, __extends } from "tslib";
import AvalonGTView from '@/utils/libs/BaseView';
import { Options } from 'vue-class-component';
import NavPanel from '@/components/common/NavPanel.vue';
import { PageService } from '@/views/copy/feedback/import';
import { Toast } from 'vant';
import commonConfig from '@/common/CommonConfig';
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.reportDetail = {}; // 2022/7/29 17:09 举报详情记录
        _this.showImage = false; // 2022/8/2 16:06 是否展示图片
        _this.images = []; // 2022/8/2 16:07 图片列表
        _this.imageIndex = 0; // 2022/8/2 16:13 图片位置
        return _this;
    }
    View.prototype.created = function () {
        var id = this.$route.query.id;
        this.getDetail(id);
    };
    // 2022/7/29 17:08 获取举报记录详情
    View.prototype.getDetail = function (id) {
        var _this = this;
        PageService.getReportDetail({
            id: id,
        }).then(function (data) {
            console.log('🥳 ~ data:', data);
            _this.reportDetail = data;
        });
    };
    // 2022/7/29 17:12 撤销举报
    View.prototype.revokeHandle = function () {
        var _this = this;
        PageService.cancelReport({
            id: this.reportDetail.id,
        }).then(function (data) {
            Toast('撤销成功');
            _this.reportDetail.type = 4;
            _this.reportDetail.state = 5;
            _this.reportDetail.stateShow = '已撤销';
            _this.reportDetail.stateText = "\u60A8\u7684\u4E3E\u62A5\u5DF2\u81EA\u4E3B\u64A4\u9500\uFF0C\u611F\u8C22\u60A8\u5BF9\u5E73\u53F0\u7684\u652F\u6301\u3002";
        });
    };
    // 2022/8/1 13:59 补充证据
    View.prototype.addEvidence = function () {
        this.globalCommit('setting_pageJump', 1);
        this.reportDetail.originId = this.reportDetail.id.toString();
        var params = {
            action: 15,
            route: commonConfig.Common.APPRoutes.report,
            data: this.reportDetail,
        };
        this.awlGlobalConfig.messageHandlers(params);
    };
    // 2022/8/2 16:12 改变图片的时候
    View.prototype.onChangeImage = function (newIndex) {
        this.imageIndex = newIndex + 1;
    };
    // 2022/8/2 15:44 图片放大
    View.prototype.toLookPic = function (pics, index) {
        var list = [];
        pics.map(function (item) {
            list.push(item.big);
        });
        this.showImage = true;
        this.imageIndex = index + 1;
        this.images = list;
    };
    View.prototype.toBack = function () {
        this.showImage = false;
    };
    View = __decorate([
        Options({
            components: { NavPanel: NavPanel },
        })
    ], View);
    return View;
}(AvalonGTView.BaseView));
export default View;
